import {
  getHoursDiffCeilMinutes,
  getPrimaryColor,
  hoursToText,
  JEJURO,
} from '@orcar/common-d2c';
import { Dayjs } from 'dayjs';
import styled from 'styled-components';

type MobileSearchBoxProps = {
  pickUpAt: Dayjs;
  dropOffAt: Dayjs;
  onRentalPeriodClick: () => void;
  onSearchButtonClick: () => void;
};

const MobileSearchBox = ({
  pickUpAt,
  dropOffAt,
  onRentalPeriodClick,
  onSearchButtonClick,
}: MobileSearchBoxProps) => {
  const rentalHour = getHoursDiffCeilMinutes(pickUpAt, dropOffAt);

  return (
    <Wrapper>
      <DateSection onClick={onRentalPeriodClick}>
        <DateColumn>
          <DateLabel>대여일</DateLabel>
          <DateDisplay>
            <LargeDate>{pickUpAt.format('MM.DD')}</LargeDate>
            <SmallDate>
              {pickUpAt.format('YYYY.')}
              {pickUpAt.format('dddd').replace('요일', '요일')}
            </SmallDate>
          </DateDisplay>
        </DateColumn>

        <ArrowIcon>›</ArrowIcon>

        <DateColumn>
          <DateLabel>반납일</DateLabel>
          <DateDisplay>
            <LargeDate>{dropOffAt.format('MM.DD')}</LargeDate>
            <SmallDate>
              {dropOffAt.format('YYYY.')}
              {dropOffAt.format('dddd').replace('요일', '요일')}
            </SmallDate>
          </DateDisplay>
        </DateColumn>
      </DateSection>

      <Divider />

      <TimeSection onClick={onRentalPeriodClick}>
        <TimeColumn>
          <TimeLabel>시간</TimeLabel>
          <TimeDisplay>
            <TimeText>{pickUpAt.format('HH:mm')}</TimeText>
            <TimeIcon>⌄</TimeIcon>
          </TimeDisplay>
        </TimeColumn>

        <TimeColumn>
          <TimeLabel>시간</TimeLabel>
          <TimeDisplay>
            <TimeText>{dropOffAt.format('HH:mm')}</TimeText>
            <TimeIcon>⌄</TimeIcon>
          </TimeDisplay>
        </TimeColumn>
      </TimeSection>

      <Button onClick={onSearchButtonClick}>
        검색하기 ({hoursToText(rentalHour)})
      </Button>
    </Wrapper>
  );
};

export default MobileSearchBox;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 360px;
  flex-direction: column;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.12);
  overflow: hidden;
`;

const DateSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  cursor: pointer;
`;

const DateColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const DateLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 8px;
`;

const DateDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LargeDate = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 4px;
`;

const SmallDate = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #666666;
`;

const ArrowIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${getPrimaryColor(JEJURO)};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  margin: 0 16px;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #f0f0f0;
`;

const TimeSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  cursor: pointer;
`;

const TimeColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const TimeLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-bottom: 4px;
`;

const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TimeText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${getPrimaryColor(JEJURO)};
`;

const TimeIcon = styled.div`
  font-size: 14px;
  color: #999999;
`;

const Button = styled.button`
  width: 100%;
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: ${getPrimaryColor(JEJURO)};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${getPrimaryColor(JEJURO)};
    opacity: 0.9;
  }
`;
